import React, { useEffect, useState } from "react";
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";

const Settings = () => {
    const [status, setStatus] = useState('NA');

    useEffect(() => {
        getSettingsData();
    }, []);

    const getSettingsData = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/settings/status', config);
            setStatus(resp.data);
        } catch(err) {
            toast.error('API error getting settings');
        }
    };

    const renderAppliances = () => {
        if (!Array.isArray(status.priorityList)) return "Not available";
        return status.priorityList.map((appliance) => appliance.id).join(", ");
    };

    const renderSettingsData = () => {
        const isLoading = status === 'NA';
        const rows = [
            ["Presence", isLoading ? "Loading…" : status.occupants ? "At home" : "Away"],
            ["Optimization", isLoading ? "Loading…" : status.optimization ? "On" : "Off"],
            ["Appliance priority", isLoading ? "Loading…" : renderAppliances()],
            ["PV threshold", isLoading ? "Loading…" : status.pv_threshold],
            ["Battery activation", isLoading ? "Loading…" : status.batt_active_threshold],
            ["Battery deactivation", isLoading ? "Loading…" : status.batt_deactive_threshold],
            ["Dual fuel", isLoading ? "Loading…" : status.dual_fuel ? "On" : "Off"],
            ["Season", isLoading ? "Loading…" : status.season],
            ["Configuration version", isLoading ? "Loading…" : status.version || "1.0"],
        ];

        return (
            <dl className="settings-grid">
                {rows.map(([label, value]) => (
                    <div key={label}>
                        <dt>{label}</dt>
                        <dd>{value ?? "Not available"}</dd>
                    </div>
                ))}
            </dl>
        );
    };

    return (
        <div className="right_col" role="main">
            <header className="page-heading">
                <div>
                    <p className="eyebrow">PLATFORM CONFIGURATION</p>
                    <h1>Settings</h1>
                    <p>Current operating values and configuration for the Domus IoT environment.</p>
                </div>
            </header>
            <div className="row">
                <div className="col-md-12">
                    <div className="x_panel">
                        <div className="x_title">
                            <h2>Current configuration</h2>
                            <div className="clearfix"></div>
                        </div>

                        <div className="x_content">
                            { renderSettingsData() }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
